import { useAccount, useConfig } from "wagmi";
import { useClient, useWriteContract } from "wagmi";
import { useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import lpclaimerAbi from "../assets/abis/lpclaimer.json";
import lpDividendAbi from "../assets/abis/lpDividendAbi.json";
import {  lpDividend,lpclaimer, MIN, MAX } from "../constants";
import { parseEther, formatUnits } from "viem";
import { waitForTransactionReceipt } from "viem/actions";

const generateRandomAmount = () => {
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
function useW3LPReward() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())
  const [loading, setLoading] = useState(false)
  const client = useClient()
  const { writeContractAsync, waitForTransactionReceipt } = useWriteContract();

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const Rewards = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: lpDividendAbi,
            address: lpDividend,
            functionName: 'usdtDivid',
            args: [address]
          },
          {
            abi: lpDividendAbi,
            address: lpDividend,
            functionName: 'wpgeoDivid',
            args: [address]
          },
          {
            abi: lpclaimerAbi,
            address: lpclaimer,
            functionName: 'usdtDividClaimed',
            args: [address],
          },
          {
            abi: lpclaimerAbi,
            address: lpclaimer,
            functionName: 'wpgeoDividClaimed',
            args: [address],
          },
          {
            abi: lpDividendAbi,
            address: lpDividend,
            functionName: 'checkAddressExists',
            args: [address]
          }
        ],
        // multicallAddress: address,
      },[config,address])     
   console.log(Rewards)
      setValue(
        {
          USDTReward: Number(formatUnits(Rewards[0]-Rewards[2],18)),
          WPGEOReward: Number(formatUnits(Rewards[1]-Rewards[3],18)),
          addressExists: Rewards[4]
        }
    )
    } catch (e) {
      console.log(e)
    }
  }, [address, config]);
  const onWithdraWPGEOReward = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: lpclaimerAbi,
          address: lpclaimer,
          functionName: 'claimWPGEO',
          // args:[address],
          value: parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client,writeContractAsync,waitForTransactionReceipt]);
  const onWithdrawUSDTReward = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: lpclaimerAbi,
          address: lpclaimer,
          functionName: 'claimUSDT',
          // args:[address],
          value: parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [fetch, config, address, refreshTime]);
  const joinRewardPool = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const hash = await writeContractAsync({
          abi: lpDividendAbi,
          address: lpDividend,
          functionName: 'addMyAddress'
          // args: [address],
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client, writeContractAsync, waitForTransactionReceipt]);
  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime]);
  return { value, loading ,onWithdraWPGEOReward, onWithdrawUSDTReward, joinRewardPool };
}

export default useW3LPReward;